import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_undefined_server_error_modal = _resolveComponent("undefined-server-error-modal")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hHh Lpr lff",
    class: "bg-grey-1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, { elevated: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_toolbar)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_sidebar),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          _createVNode(_component_undefined_server_error_modal)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}